<script lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import { computed, defineComponent, h } from 'vue'
import MultiSelect from '../primevue/MultiSelect.vue'
import type { SelectProps } from '../primevue/select'
import { toStringArray } from './formkit-utils'

export default defineComponent({
  props: {
    context: { type: Object as () => FormKitFrameworkContext & Partial<SelectProps>, required: true }
  },
  setup(props) {
    const modelValue = computed(() => toStringArray(props.context.value))

    // h() passes context.slots as native Vue slots — template-based forwarding wraps them
    // in a component boundary that breaks PrimeVue's option click handling
    return () => {
      const { readonly, ...attrs } = props.context.attrs
      return h(
        MultiSelect,
        {
          ...attrs,
          disabled: readonly || attrs.disabled,
          options: props.context.options,
          loadOptions: props.context.loadOptions,
          ensureSelected: props.context.ensureSelected,
          showFilter: props.context.showFilter,
          maxOptions: props.context.maxOptions,
          modelValue: modelValue.value,
          'onUpdate:modelValue': (v: string[]) => props.context.node.input(v)
        },
        props.context.slots
      )
    }
  }
})
</script>
